// Color tokens ****************************************************************************************************
// main: The main shade of the color
// light: A lighter shade of main
// dark: A darker shade of main (Main hover color for the design tokens)
// contrastText: Text color, intended to contrast with main

// Default colors ****************************************************************************************************
// primary - for primary interface elements.
// secondary - for secondary interface elements.
// error - for elements that the user should be made aware of.
// warning - for potentially dangerous actions or important messages.
// info - for highlighting neutral information.
// success - for indicating the successful completion of an action that the user triggered.

// ********************************************************************************************************************
// Brand color palette as described in Front
// These will override the values in the default palette
// ********************************************************************************************************************
import TOKENS from '../theme/tokens.scss';

// main:
// light:
// dark:
// contrastText:
// border:

const BRAND_PALETTE = {
	// Default theme colors
	primary: {
		main: '#0449bc', // TOKENS.primaryBgColor
		light: '#f8fafd', // TOKENS.primaryBgLightColor,
		dark: '#0326a5', // TOKENS.primaryBgHoverColor,
		contrastText: '#356ccd', // TOKENS.primaryTextColor,
	},
	// Secondary color from MUI
	base: {
		main: TOKENS.baseBgColor,
		light: TOKENS.baseBgLightColor,
		dark: TOKENS.baseBgHoverColor,
		contrastText: TOKENS.baseTextLightColor,
		border: TOKENS.baseBorderColor,
	},
	// Error color from MUI
	danger: {
		main: TOKENS.dangerBgColor,
		light: TOKENS.dangerBgLightColor,
		dark: TOKENS.dangerBgHoverColor,
		contrastText: TOKENS.dangerTextColor,
		border: TOKENS.dangerBorderColor,
	},
	orange: {
		main: '#FE7C2C',
		light: '#FFE4D2',
		dark: '#E86B1D',
		contrastText: '#FFFFFF',
		border: '#E86B1D',
	},
	warning: {
		main: '#5c5300', // TOKENS.warningBgColor,
		light: '#fffce2', // TOKENS.warningBgLightColor,
		dark: '#403a00', // TOKENS.warningBgHoverColor,
		contrastText: '#7d7000', // TOKENS.warningTextColor,
		border: '#f3db00', // TOKENS.warningBorderColor,
	},
	// info: {} (there is not infor color on the TOKENS just on MUI)
	success: {
		main: '#006015', // TOKENS.successBgColor,
		light: '#f6fcf7', // TOKENS.successBgLightColor,
		dark: '#004302', // TOKENS.successBgHoverColor,
		contrastText: '#00812a', // TOKENS.successTextColor,
		border: TOKENS.successBorderColor,
	},

	disabled: {
		opacity: TOKENS.disabledOpacity,
	},

	// Main frame
	body: {
		main: TOKENS.bodyTextColor,
	},
	header: {
		main: TOKENS.headerBaseBgColor,
		contrastText: TOKENS.headerBaseTextColor,
	},

	// Palette colors
	// fuchsia: {
	// 	10: TOKENS.colorFuchsia10,
	// 	20: TOKENS.colorFuchsia20,
	// 	30: TOKENS.colorFuchsia30,
	// 	40: TOKENS.colorFuchsia40,
	// 	50: TOKENS.colorFuchsia50,
	// 	60: TOKENS.colorFuchsia60,
	// 	70: TOKENS.colorFuchsia70,
	// 	80: TOKENS.colorFuchsia80,
	// 	90: TOKENS.colorFuchsia90,
	// 	5: TOKENS.colorFuchsia05,
	// },
	gray: {
		colorGray10: TOKENS.colorGray10,
		colorGray20: TOKENS.colorGray20,
		colorGray30: TOKENS.colorGray30,
		colorGray40: TOKENS.colorGray40,
		colorGray50: TOKENS.colorGray50,
		colorGray60: TOKENS.colorGray60,
		colorGray70: TOKENS.colorGray70,
		colorGray80: TOKENS.colorGray80,
		colorGray90: TOKENS.colorGray90,
		colorGray05: TOKENS.colorGray05,
	},
	green: {
		colorGreen10: TOKENS.colorGreen10,
		colorGreen20: TOKENS.colorGreen20,
		colorGreen30: TOKENS.colorGreen30,
		colorGreen40: TOKENS.colorGreen40,
		colorGreen50: TOKENS.colorGreen50,
		colorGreen60: TOKENS.colorGreen60,
		colorGreen70: TOKENS.colorGreen70,
		colorGreen80: TOKENS.colorGreen80,
		colorGreen90: TOKENS.colorGreen90,
		colorGreen05: TOKENS.colorGreen05,
	},
	indigo: {
		colorIndigo10: TOKENS.colorIndigo10,
		colorIndigo20: TOKENS.colorIndigo20,
		colorIndigo30: TOKENS.colorIndigo30,
		colorIndigo40: TOKENS.colorIndigo40,
		colorIndigo50: TOKENS.colorIndigo50,
		colorIndigo60: TOKENS.colorIndigo60,
		colorIndigo70: TOKENS.colorIndigo70,
		colorIndigo80: TOKENS.colorIndigo80,
		colorIndigo90: TOKENS.colorIndigo90,
		colorIndigo05: TOKENS.colorIndigo05,
	},
	blue: {
		colorBlue10: TOKENS.colorBlue10,
		colorBlue20: TOKENS.colorBlue20,
		colorBlue30: TOKENS.colorBlue30,
		colorBlue40: TOKENS.colorBlue40,
		colorBlue50: TOKENS.colorBlue50,
		colorBlue60: TOKENS.colorBlue60,
		colorBlue70: TOKENS.colorBlue70,
		colorBlue80: TOKENS.colorBlue80,
		colorBlue90: TOKENS.colorBlue90,
		colorBlue05: TOKENS.colorBlue05,
	},
	navy: {
		colorNavy10: TOKENS.colorNavy10,
		colorNavy20: TOKENS.colorNavy20,
		colorNavy30: TOKENS.colorNavy30,
		colorNavy40: TOKENS.colorNavy40,
		colorNavy50: TOKENS.colorNavy50,
		colorNavy60: TOKENS.colorNavy60,
		colorNavy70: TOKENS.colorNavy70,
		colorNavy80: TOKENS.colorNavy80,
		colorNavy90: TOKENS.colorNavy90,
		colorNavy05: TOKENS.colorNavy05,
	},
	white: { colorWhite: TOKENS.colorWhite },
	black: { colorBlack: TOKENS.colorBlack },
	// purple: {
	// 	10: TOKENS.colorPurple10,
	// 	20: TOKENS.colorPurple20,
	// 	30: TOKENS.colorPurple30,
	// 	40: TOKENS.colorPurple40,
	// 	50: TOKENS.colorPurple50,
	// 	60: TOKENS.colorPurple60,
	// 	70: TOKENS.colorPurple70,
	// 	80: TOKENS.colorPurple80,
	// 	90: TOKENS.colorPurple90,
	// 	5: TOKENS.colorPurple05,
	// },
	red: {
		colorRed10: TOKENS.colorRed10,
		colorRed20: TOKENS.colorRed20,
		colorRed30: TOKENS.colorRed30,
		colorRed40: TOKENS.colorRed40,
		colorRed50: TOKENS.colorRed50,
		colorRed60: TOKENS.colorRed60,
		colorRed70: TOKENS.colorRed70,
		colorRed80: TOKENS.colorRed80,
		colorRed90: TOKENS.colorRed90,
		colorRed05: TOKENS.colorRed05,
	},
	// teal: {
	// 	10: TOKENS.colorTeal10,
	// 	20: TOKENS.colorTeal20,
	// 	30: TOKENS.colorTeal30,
	// 	40: TOKENS.colorTeal40,
	// 	50: TOKENS.colorTeal50,
	// 	60: TOKENS.colorTeal60,
	// 	70: TOKENS.colorTeal70,
	// 	80: TOKENS.colorTeal80,
	// 	90: TOKENS.colorTeal90,
	// 	5: TOKENS.colorTeal05,
	// },
	// yellow: {
	// 	10: TOKENS.colorYellow10,
	// 	20: TOKENS.colorYellow20,
	// 	30: TOKENS.colorYellow30,
	// 	40: TOKENS.colorYellow40,
	// 	50: TOKENS.colorYellow50,
	// 	60: TOKENS.colorYellow60,
	// 	70: TOKENS.colorYellow70,
	// 	80: TOKENS.colorYellow80,
	// 	90: TOKENS.colorYellow90,
	// 	5: TOKENS.colorYellow05,
	// },

	// Layout
	breakpoint: {
		xs: TOKENS.breakpointXs,
		sm: TOKENS.breakpointSm,
		md: TOKENS.breakpointMd,
		lg: TOKENS.breakpointLg,
		xl: TOKENS.breakpointXl,
	},
	gridGap: {
		1: TOKENS.gridGap1,
		2: TOKENS.gridGap2,
		3: TOKENS.gridGap3,
		4: TOKENS.gridGap4,
		5: TOKENS.gridGap5,
		6: TOKENS.gridGap6,
		7: TOKENS.gridGap7,
		8: TOKENS.gridGap8,
		9: TOKENS.gridGap9,
		10: TOKENS.gridGap10,
		11: TOKENS.gridGap11,
	},

	spacing: {
		Xxs: TOKENS.spacingXxs,
		Xs: TOKENS.spacingXs,
		Sm: TOKENS.spacingSm,
		Md: TOKENS.spacingMd,
		Lg: TOKENS.spacingLg,
		Xl: TOKENS.spacingXl,
		Xxl: TOKENS.spacingXxl,
	},

	// Links
	link: {
		main: TOKENS.linkColor,
		decoration: TOKENS.linkDecoration,
		hover: TOKENS.linkHoverColor,
		hoverDecoration: TOKENS.linkHoverDecoration,
	},

	// text muted
	muted: {
		main: TOKENS.textMutedColor,
	},

	// Typography
	font: {
		size1: TOKENS.fontSize1,
		size2: TOKENS.fontSize2,
		size3: TOKENS.fontSize3,
		size4: TOKENS.fontSize4,
		size5: TOKENS.fontSize5,
		size6: TOKENS.fontSize6,
		size7: TOKENS.fontSize7,
		size8: TOKENS.fontSize8,
		size9: TOKENS.fontSize9,
		size10: TOKENS.fontSize10,
		size11: TOKENS.fontSize11,
		weightLight: TOKENS.fontWeightLight,
		weightRegular: TOKENS.fontWeightRegular,
		weightBold: TOKENS.fontWeightBold,
		weightBlack: TOKENS.fontWeightBlack,
	},
	fontFamily: { main: TOKENS.fontFamily },
	fontWeight: {
		light: TOKENS.fontWeightLight,
		regular: TOKENS.fontWeightRegular,
		bold: TOKENS.fontWeightBold,
		black: TOKENS.fontWeightBlack,
	},
	textSize: {
		sizeXs: TOKENS.textSizeXs,
		sizeSm: TOKENS.textSizeSm,
		sizeMd: TOKENS.textSizeMd,
		sizeLg: TOKENS.textSizeLg,
	},
	textTransform: {
		uppercase: TOKENS.textTransformUppercase,
		lowercase: TOKENS.textTransformLowercase,
		capitalize: TOKENS.textTransformCapitalize,
		none: TOKENS.textTransformNone,
	},
	heading: {
		color: TOKENS.headingColor,
		margin: {
			top: TOKENS.headingMarginTop,
			bottom: TOKENS.headingMarginBottom,
		},
		font: {
			family: TOKENS.headingFontFamily,
			weight: TOKENS.headingFontWeight,
		},
		lineHeight: TOKENS.headingLineHeight,
	},
	h1: {
		size: TOKENS.h1Size,
		weight: TOKENS.h1Weight,
	},
	h2: {
		size: TOKENS.h2Size,
		weight: TOKENS.h2Weight,
	},
	h3: {
		size: TOKENS.h3Size,
		weight: TOKENS.h3Weight,
	},
	h4: {
		size: TOKENS.h4Size,
		weight: TOKENS.h4Weight,
	},
	h5: {
		size: TOKENS.h5Size,
		weight: TOKENS.h5Weight,
	},
	h6: {
		size: TOKENS.h6Size,
		weight: TOKENS.h6Weight,
	},
	letterSpacing: {
		tighter: TOKENS.letterSpacingTighter,
		tight: TOKENS.letterSpacingTight,
		normal: TOKENS.letterSpacingNormal,
		wide: TOKENS.letterSpacingWide,
		wider: TOKENS.letterSpacingWider,
		widest: TOKENS.letterSpacingWidest,
	},
	lineHeight: {
		Sm: TOKENS.lineHeightSm,
		Md: TOKENS.lineHeightMd,
		Lg: TOKENS.lineHeightLg,
		Xl: TOKENS.lineHeightXl,
	},

	// Border radius
	borderRadius: {
		Sm: TOKENS.borderRadiusSm,
		Md: TOKENS.borderRadiusMd,
		Lg: TOKENS.borderRadiusLg,
	},

	// Icon
	iconSize: {
		Xs: TOKENS.iconSizeXs,
		Sm: TOKENS.iconSizeSm,
		Md: TOKENS.iconSizeMd,
		Lg: TOKENS.iconSizeLg,
		Xl: TOKENS.iconSizeXl,
	},

	// Image
	imageWidth: {
		sm: TOKENS.imageWidthSm,
		md: TOKENS.imageWidthMd,
		lg: TOKENS.imageWidthLg,
		xl: TOKENS.imageWidthXl,
	},
	imageSize: {
		xs: TOKENS.imageSizeXs,
		sm: TOKENS.imageSizeSm,
		md: TOKENS.imageSizeMd,
		lg: TOKENS.imageSizeLg,
		xl: TOKENS.imageSizeXl,
	},

	// custom variables
	downloadDocuments: {
		main: '#272626',
	},
	downloadHeader: {
		main: '#69707D',
	},
	downloadSubHeader: {
		main: '#343741',
	},
	trackingDrawer: {
		statuses: '#727272',
		text: '#4A4A4A',
		bol: '#282828',
		dotBackgroundMain: '#E1E1E1',
		dotBackgroundCompleted: '#98CEEA',
	},
	statuses: {
		main: 'BDBDBD',
		danger: '#BB0000',
		success: '#8bc34a',
	},
};

// Design Tokens Variables
// animation: {
// 	delay: {
// 		tiny: TOKENS.animationDelayTiny,
// 		small: TOKENS.animationDelaySmall,
// 		medium: TOKENS.animationDelayMedium,
// 		big: TOKENS.animationDelayBig,
// 		huge: TOKENS.animationDelayHuge,
// 	},
// 	speed: {
// 		slower: TOKENS.animationSpeedsLower,
// 		slow: TOKENS.animationSpeedsLow,
// 		normal: TOKENS.animationSpeedNormal,
// 		fast: TOKENS.animationSpeedFast,
// 		faster: TOKENS.animationSpeedFaster,
// 	},
// 	easing: {
// 		functional: {
// 			common: TOKENS.animationEasingFunctionalCommon,
// 			enter: TOKENS.animationEasingFunctionalEnter,
// 			exit: TOKENS.animationEasingFunctionalExit,
// 		},
// 		graceful: {
// 			common: TOKENS.animationEasingGracefulCommon,
// 			enter: TOKENS.animationEasingGracefulEnter,
// 			exit: TOKENS.animationEasingGracefulExit,
// 		},
// 	},
// },

// zindex: {
// 	dropdown: TOKENS.zindexDropdown,
// 	sticky: TOKENS.zindexSticky,
// 	fixed: TOKENS.zindexFixed,
// 	modalBackdrop: TOKENS.zindexModalBackdrop,
// 	modal: TOKENS.zindexModal,
// 	popover: TOKENS.zindexPopover,
// 	tooltip: TOKENS.zindexTooltip,
// },
// surface: {
// 	white: {
// 		color: TOKENS.surfaceWhiteColor,
// 	},
// 	dark: {
// 		color: TOKENS.surfaceDarkColor,
// 	},
// },
// link: {
// 	color: TOKENS.linkColor,
// 	decoration: TOKENS.linkDecoration,
// 	hover: {
// 		color: TOKENS.linkHoverColor,
// 		decoration: TOKENS.linkHoverDecoration,
// 	},
// },
// backdrop: {
// 	color: TOKENS.backdropColor,
// },
// heading: {
// 	color: TOKENS.headingColor,
// 	margin: {
// 		top: TOKENS.headingMarginTop,
// 		bottom: TOKENS.headingMarginBottom,
// 	},
// 	font: {
// 		family: TOKENS.headingFontFamily,
// 		weight: TOKENS.headingFontWeight,
// 	},
// 	lineHeight: TOKENS.headingLineHeight,
// },
// h1: {
// 	size: TOKENS.h1Size,
// 	weight: TOKENS.h1Weight,
// },
// h2: {
// 	size: TOKENS.h2Size,
// 	weight: TOKENS.h2Weight,
// },
// h3: {
// 	size: TOKENS.h3Size,
// 	weight: TOKENS.h3Weight,
// },
// h4: {
// 	size: TOKENS.h4Size,
// 	weight: TOKENS.h4Weight,
// },
// h5: {
// 	size: TOKENS.h5Size,
// 	weight: TOKENS.h5Weight,
// },
// h6: {
// 	size: TOKENS.h6Size,
// 	weight: TOKENS.h6Weight,
// },
// display: {
// 	sm: TOKENS.displaySm,
// 	md: TOKENS.displayMd,
// },
// hr: {
// 	color: TOKENS.hrColor,
// 	height: TOKENS.hrHeight,
// 	opacity: TOKENS.hrOpacity,
// },
// listMarginBottom: TOKENS.listMarginBottom,
// dtFontWeight: TOKENS.dtFontWeight,
// fontFamily: TOKENS.fontFamily,
// paragraphMarginBottom: TOKENS.paragraphMarginBottom,
// markBgcolor: TOKENS.markBgColor,
// body: {
// 	text: {
// 		color: TOKENS.bodyTextColor,
// 		size: TOKENS.bodyTextSize,
// 		weight: TOKENS.bodyTextWeight,
// 	},
// 	bg: {
// 		color: TOKENS.bodyBgColor,
// 	},
// },
// focusOutline: {
// 	color: TOKENS.focusOutlineColor,
// 	width: TOKENS.focusOutlineWidth,
// 	style: TOKENS.focusOutlineStyle,
// },
// disabled: {
// 	opacity: TOKENS.disabledOpacity,
// },

// test :)

export default BRAND_PALETTE;
